import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function CustomToastContainer({
  position = 'top-right',
  autoClose = false,
  newestOnTop = false,
  closeOnClick = false,
  rtl = false,
  pauseOnFocusLoss = false,
  draggable = false,
  theme = 'light',
  ...props
}) {
  return (
    <ToastContainer
      // @ts-ignore
      position={position}
      // @ts-ignore
      autoClose={autoClose}
      hideProgressBar={false}
      newestOnTop={newestOnTop}
      closeOnClick={closeOnClick}
      rtl={rtl}
      pauseOnFocusLoss={pauseOnFocusLoss}
      draggable={draggable}
      pauseOnHover={true}
      // @ts-ignore
      theme={theme}
      // @ts-ignore
      limit={null}
      closeButton={true}
      containerId="default"
      enableMultiContainer={false}
      icon={true}
      role="alert"
      transition={undefined}
      {...props}
    />
  );
}

export default CustomToastContainer;
